import styled from 'styled-components'
import Information from './information'
import About from './about'
import { useIgoBaseInfo, useIgoPoolInfo } from '../../hooks/usePoolInfo'
import { useSearchParams } from 'react-router-dom'

export default function IgoDetail() {
  const [params] = useSearchParams()
  const id = Number(params.get('id'))

  const igoInfo = useIgoBaseInfo(id)
  const poolInfo = useIgoPoolInfo(igoInfo?.sale_contract)

  return (
    <IgoDetailWrapper>
      <Title>{igoInfo?.title}</Title>
      <Information poolInfo={poolInfo} />
      <About poolInfo={poolInfo} igoInfo={igoInfo} />
    </IgoDetailWrapper>
  )
}

const IgoDetailWrapper = styled.div`
  width: 1150px;
  position: relative;
  padding: 42px 0;
  margin: 0 auto;
`

const Title = styled.h3`
  height: 70px;
  font-size: 28px;
  color: #fff;
  text-align: center;
  line-height: 70px;
  background: linear-gradient(270deg, #00246e 0%, #bb29d5 52%, #002266 100%);
`
